const validation = (values) => {
  const errors = {};
  if (!values.email) {
    errors.email = 'Required';
  } else if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.email = 'Invalid email';
  }
  if (!values.password) {
    errors.password = 'Required';
  }

  if (values?.password?.length < 6) {
    errors.password = 'Enter minimum of 6 characters';
  }

  if (!values.password_confirmation) {
    errors.password_confirmation = 'Required';
  }

  if (values.password && values.password_confirmation && (values.password !== values.password_confirmation)) {
    errors.password_confirmation = 'Should match password';
  }

  if(!values.name){
    errors.name = 'required'
  }

  if(!values.title){
    errors.title = 'required'
  }

  if(!values.color_hex) {
    errors.color_hex = 'required'
  }

  if(!values.first_name){
    errors.first_name = 'required'
  }

  if(!values.last_name){
    errors.last_name = 'required'
  }

  if(!values.description){
    errors.description = 'required'
  }

  return errors;
};

export default validation;
